import React from "react";

export const Instruction = ({ number, instruction }) => {
  return (
    <li className="d-flex m-4 justify-content-center">
      <section className="d-flex flex-column align-items-center">
        <p className="htp-web-instructions__number">{number}</p>
        <p className="text-center mt-2">{instruction}</p>
      </section>
    </li>
  );
};

export const Instructions = ({ children }) => {
  return (
    <section className="htp-web-instructions">
      <ol className="flex-column flex-md-row d-flex">{children}</ol>
    </section>
  );
};
